export default function (dom, opts) {
    let options = {
        buttonSel: '[data-more-images]',
        buttonTextSel: '[data-text]',
        iconSel: '.neighbouring-caret',
        iconRotateCls: 'neighbouring-caret--rotate',
        shadowCls: 'collapsible__content--shadow',
        galleryWrapperSel: ".gallery__wrapper",
        ...opts
    };

    const desktopWidth = 1024;
    const baseClass = 'collapsible';
    const body = document.documentElement;
    const showMoreButton = dom.querySelector(options.buttonSel);
    const buttonText = dom.querySelector(options.buttonTextSel);
    const arrowIcon = dom.querySelector(options.iconSel);
    const content = dom.querySelector(`.${baseClass}__content`);
    const galleryItems = dom.querySelectorAll('.gallery__wrapper > li')
    const gallery = dom.querySelector('.gallery__wrapper')

    if (galleryItems.length < 6) {
        showMoreButton.style.display = 'none';
    }
    if (galleryItems.length >= 6) {

        gallery.classList.add("collapsible__content");

    }

    const contentTransition = e => {
        dom.querySelector('.collapsible__content').removeEventListener('transitionend', contentTransition);
        dom.querySelector('.collapsible__content').style.maxHeight = '';
    };

    if (!dom.classList.contains(`${baseClass}--collapsed`) && window.innerWidth < desktopWidth) {
        dom.classList.add(`${baseClass}--collapsed`);
    }

    showMoreButton && dom.querySelector('.collapsible__content') && showMoreButton.addEventListener('click', e => {
        const testContent = dom.querySelector(`.collapsible__content`);
        e.preventDefault();
        showMoreButton.remove();

        testContent.removeEventListener('transitionend', contentTransition);
        testContent.addEventListener('transitionend', contentTransition);

        testContent.style.maxHeight = `${testContent.scrollHeight}px`;

        setTimeout(() => {
            dom.classList.toggle(`${baseClass}--collapsed`);

        }, 25);

        return false;
    });

}
